import { Link } from 'react-router-dom';
import CustomPageTiles from '../components/CustomPageTiles';
import Header from '../components/Header';

function MathsMisc() {
  return <>
    <Header />
    
    <div id="tiles">
        <Link id="maths-penguins" className='link' to="/maths/penguins">
            <span>Tučniaky</span>
        </Link>
        <Link id="maths-shapes" className='link' to="/maths/shapes">
            <span>Symetria</span>
        </Link>
        <CustomPageTiles path="/maths" />
    </div>
  </>
}

export default MathsMisc;
